<template>
  <div>
    <div v-if="isLoading">
      <OtherLoading />
    </div>
    <div v-else>
      <b-modal
        v-model="showModal"
        ref="modal-point"
        @show="show"
        @hidden="hide"
        centered
      >
        <template #modal-header>
          <div class="ft-black">
            {{ typePoint === 1 ? "Center Point" : "Branch Point" }}
          </div>
        </template>
        <div>
          <b-tabs fill v-model="tabIndex">
            <!-- Increase = 1 -->
            <b-tab
              title="Add Points"
              @click.prevent="$emit('tabIndexPoint', 0)"
            >
              <div class="p-3">
                <div v-if="typePoint === 2" class="mb-3">
                  <InputSelect
                    title="Select Branch"
                    name="branch"
                    isRequired
                    noPleaseSelect
                    class="mt-2"
                    :isValidate="v.branch_id.$error"
                    v-bind:options="branchList"
                    v-model="form.branch_id"
                    valueField="id"
                    textField="name"
                    @onDataChange="selectBranch($event)"
                  />
                </div>
                <div>
                  <b-row>
                    <b-col
                      class="text-right current-point"
                      v-if="typePoint === 1"
                      >Current Point
                      {{ point.center_point | numeral("0,0") }} Point</b-col
                    >
                    <b-col
                      v-if="typePoint === 2"
                      class="text-right current-point"
                      >Current Point
                      {{ pointBranch | numeral("0,0") }} Point</b-col
                    >
                  </b-row>
                  <InputText
                    textFloat="Add Points"
                    placeholder="Add Points"
                    type="number"
                    name="add_point"
                    v-model="form.addPoint"
                    :isValidate="v.addPoint.$error"
                    @onDataChange="changePoint"
                  />
                </div>
                <div>
                  <InputText
                    v-if="typePoint === 1"
                    textFloat="All Points"
                    placeholder="All Points"
                    type="number"
                    v-model="totalPoint"
                    name="total_point"
                    :disabled="true"
                  />
                  <InputText
                    v-if="typePoint === 2"
                    textFloat="All Points"
                    placeholder="All Points"
                    v-model="totalPoint"
                    type="number"
                    name="total_point"
                    :disabled="true"
                  />
                </div>
                <div>
                  <InputTextArea
                    :rows="4"
                    textFloat="Save"
                    placeholder="Save"
                    id="note1"
                    v-model="form.note"
                  />
                </div>
              </div>
            </b-tab>
            <!-- Decrease = 2  -->
            <b-tab title="Reduce Points" @click.prevent="$emit('tabIndexPoint', 1)">
              <div class="p-3">
                <div v-if="typePoint === 2" class="mb-3">
                  <InputSelect
                    title="Select Branch"
                    name="branch"
                    isRequired
                    class="mt-2"
                    noPleaseSelect
                    v-bind:options="branchList"
                    v-model="form.branch_id"
                    valueField="id"
                    textField="name"
                    @onDataChange="selectBranch($event)"
                  />
                </div>
                <div>
                  <b-row>
                    <b-col
                      class="text-right current-point"
                      v-if="typePoint === 1"
                      >Current Point
                      {{ point.center_point | numeral("0,0") }} Point</b-col
                    >
                    <b-col
                      v-if="typePoint === 2"
                      class="text-right current-point"
                      >Current Point
                      {{ pointBranch | numeral("0,0") }} Point</b-col
                    >
                  </b-row>
                  <InputText
                    textFloat="Reduce Points"
                    placeholder="Reduce Points"
                    type="number"
                    name="delete_point"
                    v-model="form.deletePoint"
                    :isValidate="v.deletePoint.$error"
                    @onDataChange="changePoint"
                  />
                </div>
                <div>
                  <InputText
                    v-if="typePoint === 1"
                    textFloat="All Points"
                    placeholder="All Points"
                    v-model="totalDeletePoint"
                    type="number"
                    name="total_point"
                    :disabled="true"
                  />
                  <InputText
                    v-if="typePoint === 2"
                    textFloat="All Points"
                    placeholder="All Points"
                    v-model="totalDeletePoint"
                    type="number"
                    name="total_point"
                    :disabled="true"
                  />
                </div>
                <div>
                  <InputTextArea
                    :rows="4"
                    textFloat="Save"
                    placeholder="Save"
                    id="note2"
                    v-model="form.note"
                  />
                </div>
              </div>
            </b-tab>
            <!-- Adjust = 3 -->
            <b-tab
              title="Edit Point"
              @click.prevent="$emit('tabIndexPoint', 2)"
            >
              <div class="p-3">
                <div v-if="typePoint === 2" class="mb-3">
                  <InputSelect
                    title="Select Branch"
                    name="branch"
                    noPleaseSelect
                    isRequired
                    class="mt-2"
                    v-bind:options="branchList"
                    v-model="form.branch_id"
                    valueField="id"
                    :isValidate="v.branch_id.$error"
                    textField="name"
                    @onDataChange="selectBranch($event)"
                  />
                </div>
                <div>
                  <b-row>
                    <b-col
                      v-if="typePoint === 1"
                      class="text-right current-point"
                      >Current Point
                      {{ point.center_point | numeral("0,0") }} Point</b-col
                    >
                    <b-col
                      v-if="typePoint === 2"
                      class="text-right current-point"
                      >Current Point
                      {{ pointBranch | numeral("0,0") }} Point</b-col
                    >
                  </b-row>
                  <InputText
                    textFloat="Edit Point"
                    placeholder="Edit Point"
                    v-model="form.editPoint"
                    :isValidate="v.editPoint.$error"
                    @onDataChange="changePoint"
                    type="number"
                    name="edit_point"
                  />
                </div>
                <div>
                  <InputTextArea
                    :rows="4"
                    textFloat="Save"
                    placeholder="Save"
                    id="note3"
                    v-model="form.note"
                  />
                </div>
              </div>
            </b-tab>
          </b-tabs>
        </div>
        <template #modal-footer>
          <b-row>
            <b-col
              ><b-button @click="hide" class="btn-cancel">
                Cancel
              </b-button></b-col
            >
            <b-col
              ><b-button class="btn-confirm" @click.prevent="confirmPoint()">
                Save
              </b-button></b-col
            >
          </b-row>
        </template>
      </b-modal>
    </div>
  </div>
</template>

<script>
import InputText from "@/components/inputs/InputText";
import InputTextArea from "@/components/inputs/InputTextArea";
import InputSelect from "@/components/inputs/InputSelect";
import OtherLoading from "@/components/loading/OtherLoading";
export default {
  components: {
    InputText,
    InputTextArea,
    InputSelect,
    OtherLoading,
  },
  props: {
    branchList: {
      required: true,
      type: Array,
    },
    form: {
      required: true,
      type: Object,
    },
    point: {
      required: true,
      type: Object,
    },
    v: {
      required: true,
      type: Object,
    },
    id: {
      required: true,
      type: String,
    },
    loading: {
      required: true,
      type: Boolean,
    },
  },
  data() {
    return {
      showModal: false,
      typePoint: 0,
      tabIndex: 0,
      totalPoint: 0,
      totalDeletePoint: this.point.center_point,
      totalEditPoint: 0,
      pointBranch: 0,
      isLoading: this.loading,
    };
  },
  watch: {
    "form.addPoint": function (value) {
      if (this.typePoint === 1) {
        this.totalPoint = parseInt(this.point.center_point);
        if (this.form.addPoint) {
          this.totalPoint =
            parseInt(this.totalPoint) + parseInt(this.form.addPoint);
        } else {
          this.totalPoint = parseInt(this.point.center_point);
        }
      } else if (this.typePoint === 2) {
        this.totalPoint = parseInt(this.pointBranch);
        if (this.form.addPoint) {
          this.totalPoint =
            parseInt(this.totalPoint) + parseInt(this.form.addPoint);
        } else {
          this.totalPoint = parseInt(this.pointBranch);
        }
      }
    },
    "form.deletePoint": function (value) {
      if (this.typePoint === 1) {
        this.totalDeletePoint = parseInt(this.point.center_point);
        if (this.form.deletePoint) {
          this.totalDeletePoint =
            parseInt(this.totalDeletePoint) - parseInt(this.form.deletePoint);
        } else {
          this.totalDeletePoint = parseInt(this.point.center_point);
        }
      } else if (this.typePoint === 2) {
        this.totalDeletePoint = parseInt(this.pointBranch);
        if (this.form.deletePoint) {
          this.totalDeletePoint =
            parseInt(this.totalDeletePoint) - parseInt(this.form.deletePoint);
        } else {
          this.totalDeletePoint = parseInt(this.pointBranch);
        }
      }
    },
    point(val) {
      this.totalDeletePoint = val.center_point;
    },
    tabIndex() {
      // if (this.tabIndex === 1) {
      //   if (this.typePoint === 1) {
      //     this.totalDeletePoint = parseInt(this.point.center_point);
      //   } else if (this.typePoint === 2) {
      //     this.totalDeletePoint = parseInt(this.pointBranch);
      //   }
      // }
      // if (this.tabIndex === 2) {
      //   this.totalEditPoint = parseInt(this.point.center_point);
      // }
    },
  },
  methods: {
    show(val) {
      console.log(val);
      if (val === 1) {
        console.log(this.point.center_point);
        this.typePoint = 1;
        this.totalPoint = this.point.center_point;
      } else if (val === 2) {
        this.typePoint = 2;
        if (!this.form.branch_id) {
          this.totalPoint = 0;
        } else {
          this.totalPoint = this.pointBranch;
        }
      }
      this.showModal = true;
    },
    hide() {
      this.form.addPoint = null;
      this.form.deletePoint = null;
      this.totalPoint = 0;
      this.form.branch_id = null;
      this.totalDeletePoint = 0;
      this.tabIndex = 0;
      this.pointBranch = 0;
      this.showModal = false;
    },
    selectBranch(evt) {
      this.form.branch_id = evt;
      this.getPointBranch();
      this.isLoading = true;
    },
    async getPointBranch() {
      let form = {
        user_guid: this.id,
        branch_id: this.form.branch_id,
      };
      await this.$store.dispatch("getPointByBranch", form);
      const data = this.$store.state.report.statePointByBranch;
      console.log(data);
      if (data.result === 1) {
        this.pointBranch = data.detail;
        this.totalPoint = this.pointBranch;

        this.totalDeletePoint = this.pointBranch;
      }
      this.isLoading = false;
    },
    changePoint(value) {
      if (this.tabIndex === 0) {
        this.form.update_type = 1;
      } else if (this.tabIndex === 1) {
        this.form.update_type = 2;
      } else if (this.tabIndex === 2) {
        this.form.update_type = 3;
      }
    },
    confirmPoint() {
      if (this.typePoint === 1) {
        this.form.branch_id = 0;
      } else if (this.typePoint === 2) {
        this.v.branch_id.$touch();
        if (this.v.branch_id.$error) {
          return;
        }
      }
      if (this.tabIndex === 0) {
        this.v.addPoint.$touch();
        if (this.v.addPoint.$error) {
          return;
        }
        this.form.update_point = parseInt(this.form.addPoint);
      } else if (this.tabIndex === 1) {
        this.v.deletePoint.$touch();
        if (this.v.deletePoint.$error) {
          return;
        }
        this.form.update_point = parseInt(this.form.deletePoint);
      } else if (this.tabIndex === 2) {
        this.v.editPoint.$touch();
        if (this.v.editPoint.$error) {
          return;
        }
        this.form.update_point = parseInt(this.form.editPoint);
      }
      this.$emit("updatePoint", this.form);
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep .modal-header {
  background-color: var(--secondary-color);
}
.ft-black {
  color: var(--font-color);
  font-weight: 600;
  font-size: 17px;
}
::v-deep .nav.nav-tabs.nav-fill {
  border: 10px solid #c5c5c5;
}
::v-deep .modal-body {
  padding: 0;
}
::v-deep .nav-tabs .nav-link.active,
.nav-tabs .nav-item.show .nav-link {
  background-color: var(--primary-color);
  border-bottom: none;
  color: #fff !important;
}
::v-deep .modal-footer {
  display: block;
}
.btn-cancel {
  background-color: transparent;
  width: 100%;
}
.btn-confirm {
  background-color: var(--primary-color);
  color: #fff;
  width: 100%;
}
.current-point {
  color: gray;
  position: absolute;
}
</style>
